import { useCallback } from "react";
import { SearchBoxProps } from "./search-box";

export type ConditionType = "and" | "or";

export type SearchBoxControllerProps = Pick<
  SearchBoxProps,
  "onChangeSearchCondition" | "onChangeSearchText"
>;

export const useSearchBoxController = ({
  onChangeSearchText,
  onChangeSearchCondition,
}: SearchBoxControllerProps) => {
  const handleOnSearchTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeSearchText(e.target.value);
    },
    [onChangeSearchText],
  );

  const handleOnSearchConditionChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeSearchCondition(e.target.value as ConditionType);
    },
    [onChangeSearchCondition],
  );

  return {
    handleOnSearchTextChange,
    handleOnSearchConditionChange,
  };
};
